import type { ColumnDef, TableColumnPref } from './types'

export function resolveColumns<TRow>(
  catalog: ColumnDef<TRow>[],
  pref: TableColumnPref | null | undefined
): { visibleColumns: ColumnDef<TRow>[]; allColumns: ColumnDef<TRow>[] } {
  const byId = new Map<string, ColumnDef<TRow>>()
  catalog.forEach((c) => byId.set(c.id, c))

  const lockedStart: ColumnDef<TRow>[] = []
  const lockedEnd: ColumnDef<TRow>[] = []
  const unlocked: ColumnDef<TRow>[] = []

  catalog.forEach((c) => {
    if (c.locked) {
      if (c.lockedPosition === 'start') lockedStart.push(c)
      else lockedEnd.push(c)
    } else {
      unlocked.push(c)
    }
  })

  lockedStart.sort((a, b) => a.defaultOrder - b.defaultOrder)
  lockedEnd.sort((a, b) => a.defaultOrder - b.defaultOrder)

  const orderPref = pref?.order ?? []
  const visibilityPref = pref?.visibility ?? {}

  let orderedUnlocked: ColumnDef<TRow>[]
  if (!orderPref.length) {
    orderedUnlocked = [...unlocked].sort(
      (a, b) => a.defaultOrder - b.defaultOrder
    )
  } else {
    const used = new Set<string>()
    const fromPref: ColumnDef<TRow>[] = []
    orderPref.forEach((id) => {
      const def = byId.get(id)
      if (def && !def.locked && !used.has(id)) {
        fromPref.push(def)
        used.add(id)
      }
    })
    const remainder = unlocked
      .filter((c) => !used.has(c.id))
      .sort((a, b) => a.defaultOrder - b.defaultOrder)
    orderedUnlocked = [...fromPref, ...remainder]
  }

  const allColumns = [...lockedStart, ...orderedUnlocked, ...lockedEnd]
  const visibleColumns = allColumns.filter((c) => {
    if (c.locked) return true
    const v = visibilityPref[c.id]
    return v === undefined ? c.defaultVisible : v
  })

  return { visibleColumns, allColumns }
}
